// ═══════════════ FINANCES - SHARED UTILITIES ═══════════════
export const uid = () => Date.now().toString(36) + Math.random().toString(36).substr(2, 6);

export const fmt = (v) =>
  new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(v || 0);
